module.exports = __webpack_public_path__ + "img/bg-pricing.c1502e60.jpg";